import axios from "axios";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const authClient = axios.create({
    baseURL: API,
    withCredentials: true, // send/receive httpOnly session cookie
    timeout: 15000,
});

export async function exchangeSession(sessionId) {
    const { data } = await authClient.post("/auth/session", { session_id: sessionId });
    return data;
}

export async function fetchMe() {
    const { data } = await authClient.get("/auth/me");
    return data;
}

export async function logout() {
    await authClient.post("/auth/logout");
}

export async function fetchApplications() {
    const { data } = await authClient.get("/applications");
    return data;
}

export function startGoogleLogin() {
    // Dynamic, browser-derived redirect — never hardcoded
    const redirectUrl = window.location.origin + "/admin/applications";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
